import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import NavigationWrapper from './components/NavigationWrapper';
import Hero from './components/Hero';
import Banner from './components/Banner';
import Problem from './components/Problem';
import Consulting1 from './components/Consulting1';
import Consulting2 from './components/Consulting2';
import Consulting3 from './components/Consulting3';
import Consulting_Features from './components/Consulting_Features';
import Solutions from './components/Solutions';
import Solutions_Dash_Wrapper from './components/Solutions_Dash_Wrapper';
import VideoTransition from './components/VideoTransition';
import Niches from './components/Niches';
import HowItWorksWrapper from './components/HowItWorksWrapper';
import CTA from './components/CTA';
import FooterWrapper from './components/FooterWrapper';
import ContactWrapper from './components/ContactWrapper';
import AboutWrapper from './components/AboutWrapper';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz2';
import CookieRichtlinie from './pages/CookieRichtlinie';
import AGB from './pages/AGB';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import LeitfadenfuerEffizienzsteigerung from './pages/BlogPosts/LeitfadenfuerEffizienzsteigerung';
import ExcelTabelleEmailShope from './pages/BlogPosts/exceltabelleemailshope';
import BackofficeAutomations from './pages/BlogPosts/6backofficeautomations';
import KIBasierteWissensdatenbanken from './pages/BlogPosts/KIBasierteWissensdatenbanken';
import AIAgentsVsWorkflows from './pages/BlogPosts/AIAgentsVsWorkflows';
import KundensupportAutomatisierung from './pages/BlogPosts/KundensupportAutomatisierung';
import CookieConsent from './components/CookieConsent';
import Pricing from './pages/Pricing';
import ThankYou from './pages/ThankYou';
import ContactThankYou from './pages/ContactThankYou';
import Unsubscribe from './pages/Unsubscribe';
import HeroShader from './pages/HeroShader';
import Hero_center from './components/Hero_center';
import NotFound from './pages/NotFound';

// Homepage Component
const HomePage = () => (
  <>
    <div className="relative">
      {/*<Hero_center />*/}
      <Hero />
    </div>
    <Banner />
    <Problem />
    <div className="relative">
      <Consulting1 />
      {/*<div className="absolute top-[calc(50%+350px)] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30 w-full">
        <div className="relative w-full">
          {/*<div className="absolute inset-0 bg-gradient-to-r from-[#070709] via-transparent to-[#070709] pointer-events-none"></div>
          {/*<h1 className="font-calsans font-bold text-[48px] tracking-[-0.02em] leading-[1.5] bg-gradient-to-r from-[#d5d8f6] from-30% via-white via-50% to-[#d5d8f6] to-70% bg-clip-text text-transparent text-center px-16">
            Don't just adopt AI.<br />
            Integrate it where it matters. 
          </h1>
        </div>
      </div>*/}
    </div>
    <div className="relative">
      <div className="relative z-0">
        <Consulting2 />
      </div>
      <div className="relative -mt-[450px] z-10">
        <Consulting3 />
      </div>
    </div>
    <Consulting_Features />
    <VideoTransition />
    <Niches />
    <Solutions_Dash_Wrapper />
    <HowItWorksWrapper />
    <CTA />
    <FooterWrapper />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#010003]">
        <ScrollToTop />
        <NavigationWrapper />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactWrapper />} />
          <Route path="/about" element={<AboutWrapper />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/cookie-richtlinie" element={<CookieRichtlinie />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/leitfaden-fuer-effizienzsteigerung" element={<LeitfadenfuerEffizienzsteigerung />} />
          <Route path="/blog/excel-tabelle-emails-hope" element={<ExcelTabelleEmailShope />} />
          <Route path="/blog/back-office-automations" element={<BackofficeAutomations />} />
          <Route path="/blog/ki-basierte-wissensdatenbanken" element={<KIBasierteWissensdatenbanken />} />
          <Route path="/blog/ai-agents-vs-workflows" element={<AIAgentsVsWorkflows />} />
          <Route path="/blog/kundensupport-automatisierung" element={<KundensupportAutomatisierung />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/contact/thank-you" element={<ContactThankYou />} />
          {/* Redirect any case variations to the correct route */}
          <Route path="/Thank-you" element={<ThankYou />} />
          <Route path="/Thank-You" element={<ThankYou />} />
          <Route path="/Contact/thank-you" element={<ContactThankYou />} />
          <Route path="/Contact/Thank-You" element={<ContactThankYou />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/heroshader" element={<HeroShader />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </div>
    </Router>
  )
}

export default App